var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tour',{attrs:{"name":"expressTour","steps":_vm.steps,"callbacks":_vm.myCallbacks}}),_c('CreateRelease',{staticClass:"mt-10",attrs:{"is-express":"","no-header":""},on:{"success":_vm.success}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }